"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getQuickPayDetail = (trackId) => {
    const requestId = 'QUICK_PAY';
    const rawEndpoint = ENDPOINTS_1.default.BOOKING_SERVICE.QUICK_PAY;
    const endPoint = rawEndpoint.replace('{trackId}', trackId.toString());
    return http_service_1.default.get(requestId, endPoint).then((response) => response.data);
};
exports.default = getQuickPayDetail;
